<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'DefaultContainer',
  data: () => {
    return {
      lang: "",
    }
  },
  created: function() {
    // console.log(this.$router.history._startLocation);
    var language = navigator.language || navigator.userLanguage;
    // console.log(language);
    if(this.$router.history._startLocation == '/') {
      if(language == 'ko' || language == 'ko-KR') {
      this.$router.push("/kr/index").catch(()=>{});
    }
    else if(language == 'en' || language == 'en-US') {
      this.$router.push("/en/index").catch(()=>{});
    }
    else {
      this.$router.push("/en/index").catch(()=>{});
    }
    }

  },
}
</script>

<style>
    @import '../assets/css/reset.css';
    @import '../assets/css/common.css';
</style>